import { OptGroup as RCOptionGroup } from 'rc-select';
import { OptGroupProps } from 'rc-select/lib/OptGroup';

export interface IOptionGroupProps extends OptGroupProps {}

const OptionGroup = RCOptionGroup;

export default OptionGroup;
